import { Component, Input, OnInit } from '@angular/core';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-deposit-logo',
  templateUrl: './deposit-logo.component.html',
  styleUrls: ['./deposit-logo.component.scss'],
})
export class DepositLogoComponent implements OnInit {
  @Input() paymentType: string;
  @Input() flag: string;

  public logoText: string;
  public logoImage: string;

  constructor(
    public cashierService: CashierService,
    public withdrawService: WithdrawalService,
    public utils: UtilsService,
  ) {

  }

  ngOnInit() {
    if (this.flag == 'withdraw') {
      this.getWithdrawalData();
    } else {
      this.getVendorData();
    }
  }

  public getPaymentImage(): string {
    let imageUrl: string;
    imageUrl = `url(${this.utils.getDepositCDNAAsset(this.logoImage)})`;
    return imageUrl;
  }

  public getVendorData() {
    this.cashierService.getActiveTypesCategories({ include_types: true }).subscribe((response: any) => {
      if (response.result) {
        // backend cage types make this check awkward (CAGE; CAGEPA)

        let filteredPayload = response.payload.filter(
          x => x.code.toUpperCase().startsWith(this.paymentType.toUpperCase())
        );

        // If no results found for PNM, try CASH
        if (filteredPayload.length === 0 && this.paymentType.toUpperCase() === 'PNM') {
          filteredPayload = response.payload.filter(
            x => x.code.toUpperCase().startsWith('CASH')
          );
        }

        if (filteredPayload.length > 0) {
          this.logoImage = filteredPayload[0].image_url;
          this.logoText = filteredPayload[0].name || '';
        }
      }
    }, (error) => console.error("Credit Card Active Type Error", error));
  }

  public getWithdrawalData() {
    this.withdrawService.getPayoutMethods().subscribe((res: any) => {
      if (res) {
        for (const paymentMethod of res) {
          if (paymentMethod?.PAYMENT_TYPE?.code === this.paymentType.toUpperCase() || paymentMethod?.PAYMENT_TYPE?.PAY_TYPE_CAT?.code === this.paymentType.toUpperCase()) {
            this.logoImage = paymentMethod?.PAYMENT_TYPE?.image_url;
            this.logoText = paymentMethod?.PAYMENT_TYPE?.name || '';
            break;
          }
        }
      }
    })
  }

}
